import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultContactInfo,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const tenantShortTermAccommodationRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    price: validationRules.price,
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    buildingType: validationRules.buildingType,
    startRentalDate: validationRules.startRentalDateRequired,
    additionalCosts: validationRules.additionalCosts,
    deposit: validationRules.deposit,
  },
  description: {
    adTitle: validationRules.adTitle,
    adDescription: validationRules.adDescription,
    adLocation: validationRules.adLocation,
  },
  otherFacilities: {
    minRentalTime: validationRules.minRentalTime,
    maxRentalTime: validationRules.maxRentalTime,
    maxNumberOfPersons: validationRules.maxNumberOfPersons,
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  contactInfo: defaultContactInfo,
}
